import React from 'react';
import styled from 'styled-components';
import { QuestionStyleTypes } from '../../form-runtime-context/contracts';
import { useQuestionStyle } from '../../form-runtime-context/form-runtime-context';
import { RequiredAsterisk } from '../../required-asterisk/required-asterisk';

export const QuestionDescriptionStyle = styled.div`
	border: 0px;
	font-size: 13px;
	width: 100%;
	color: ${props => props.theme.colors.darkGrey};
	resize: none;
	text-align: left;
	overflow: hidden !important;
`;

export const QuestionDescriptionRender = (props: { id: string; value: string; required?: boolean; style?: React.CSSProperties }) => {
	const { id, value, required, style } = props;

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.description, {}, id);

	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<QuestionDescriptionStyle
				style={{
					...style,
					fontSize,
					fontFamily,
					color,
					fontStyle,
					textDecoration,
					fontWeight
				}}
			>
				{value}
				{required ? <RequiredAsterisk /> : null}
			</QuestionDescriptionStyle>
		</div>
	);
};
